$(document).ready(function() {
  var isSmartPhone = navigator.userAgent.match(/iPhone|Android.+Mobile/);
  var product_json = $('.js-section-product').data('product-json');
  var tags = product_json.tags;
  var ACCESS_TOKEN_STORE_FRONT_API = theme_accessToken;
  var caseH1Tags = Object.keys(window.fox.settings.h1case);

  var design_code = tags.find(function(code) {
    return code.indexOf('h2_') === 0;
  });
  var base_model_code = tags.find(function(code) {
    return code.indexOf('mo_') === 0;
  });
  var base_index_no = tags.find(function(code) {
    return code.indexOf('index_') === 0;
  });
  var base_h1_code = tags.find(function(code) {
    return code.indexOf('h1_') === 0;
  });
  var isCaseProduct = caseH1Tags.indexOf(base_h1_code) > -1;
  var base_collection_code = tags.find(function(code) {
    return code.indexOf('col_') === 0;
  });
  var base_material_code = tags.find(function(code) {
    return code.indexOf('m_') === 0;
  });
  var base_player_code = tags.find(function(code) {
    return code.indexOf('pl_') === 0;
  });
  var base_f_code = tags.find(function(code) {
    return code.indexOf('f_') === 0; // note f_ は柄
  });
  var base_case_color = tags.find(function(code) {
    return code.indexOf('cscl_') === 0; // note f_ は柄
  });
  var base_sling_color = tags.find(function(code) {
    return code.indexOf('slcl_') === 0; // note f_ は柄
  });
  var base_ribbon_color = tags.find(function(code) {
    return code.indexOf('rbcl_') === 0;
  });
  /* 商品種別がケースでケースカラーなしはClearケースとして扱う */
  if (isCaseProduct && !base_case_color) {
    base_case_color = "cscl_Clear";
  }

  $('.keyword-tag a').each(function(index, element) {
    return $(element).attr('href', '/collections/all/' + base_model_code + '+' + $(element).data('href'));
  });
  var get_products_graphql = function(query, callback, cursor) {
    var cursor_query;
    if (cursor == null) {
      cursor = null;
    }
    cursor_query = '';
    if (cursor !== null) {
      cursor_query = ', after: "' + cursor + '"';
    }
    return $.ajax({
      type: 'POST',
      timeout: 8000,
      url: '/api/2024-07/graphql.json',
      headers: {
        'Content-Type': 'application/graphql',
        'X-Shopify-Storefront-Access-Token': ACCESS_TOKEN_STORE_FRONT_API
      },
      data: '{ products(query: "' + query + '", first: 250' + cursor_query + ') { edges { cursor, node { title, id, handle, tags,priceRange { minVariantPrice { amount } }, publishedAt, productType, images(first:1) { edges { node { originalSrc } } } } }, pageInfo { hasNextPage } } }',
      cache: false
    }).done(function (e) {
      return callback(e.data);
    }).fail(function(e) {
      return console.error(e);
    });
  };

  var get_all_products_graphql = function(query, callback, all_products, cursor) {
    if (all_products == null) {
      all_products = [];
    }
    if (cursor == null) {
      cursor = null;
    }
    get_products_graphql(query, function(data) {
      if (data.products.pageInfo.hasNextPage === true) {
        return get_all_products_graphql(query, callback, all_products.concat(data.products.edges), data.products.edges.slice(-1)[0].cursor);
      } else {
        return callback(all_products.concat(data.products.edges));
      }
    }, cursor);
    return true;
  };

  if (base_model_code) {
    var deleted_prefix = base_model_code.split('_')[1]
    var base_model_name = window.fox.settings.model[deleted_prefix];

    $('.js-model').text('for ' + base_model_name);
  }

  //商品ページのタイトル
  var base_casetype_name = tags.find(function(code) {
    return code.indexOf('h1_') === 0;
  });
  var base_itemtitle = tags.find(function (code) {
    return code.indexOf('productname_') === 0;
  });
  if (base_casetype_name) {
    var base_casetype_name = window.fox.settings.h1[base_casetype_name];
    if(base_h1_code == 'h1_FM' && base_case_color.includes('with BlackRing')){
      base_casetype_name = window.fox.settings.h1['h1_FM_black_ring'];
    }
    $('.js-product-title').html(base_casetype_name + '<br>'); // 一番上に表示
  }
  
  var base_collection_code = tags.find(function(code) {
    return code.indexOf('col_') === 0; // "col_"タグを検索
  });
  
  if (base_collection_code) {
    var collection_name = base_collection_code.replace('col_', ''); // "col_"を取り除く
    $('.js-product-title').append(collection_name + '<br>'); // h1_の次に表示
  }
  
  // 新しい部分：dsgn_〇〇タグの内容を取得して表示
  var base_design_code = tags.find(function(code) {
    return code.indexOf('dsgn_') === 0; // "dsgn_"タグを検索
  });
  
  if (base_design_code) {
    var design_name = base_design_code.replace('dsgn_', ''); // "dsgn_"を取り除く
    $('.js-product-title').append(design_name); // 最後に表示（改行不要）
  }
  
  // 元のproductname_コード（コメントアウト）
  /*
  if (base_itemtitle) {
    base_itemtitle = base_itemtitle.replace('productname_', '');
    $('.js-product-title').append(base_itemtitle); // col_の次に表示（最後なので改行不要）
  }
  */
  

  var model_links = {};
  var casetype_selector = {};
  var casetype_links = {};
  var casecolor_links = {};
  //ケースタイプの変数
  var base_casetype_color;
  var casetype_color;
  var casetypecolor_label_replace;
  var casetypecolor_text;

  //ケースタイプをセットする関数
  var casetype_set = function(set_base_casetype_color, set_casetype_color, set_casetypecolor_label_replace, set_casetypecolor_text) {
    base_casetype_color = set_base_casetype_color;
    casetype_color = set_casetype_color;
    casetypecolor_label_replace = set_casetypecolor_label_replace;
    casetypecolor_text = set_casetypecolor_text;
  }
  get_all_products_graphql('tag:\\"' + design_code + '\\" AND tag:\\"' + base_index_no + '\\"', function(products) {
    for (l = 0, len2 = products.length; l < len2; l++) {
      var product = products[l];
      var product_info = product.node;
      var model_code = product_info.tags.find(function(code) {
        return code.indexOf('mo_') === 0;
      });
      var index_no = product_info.tags.find(function(code) {
        return code.indexOf('index_') === 0;
      });
      var h1_code = product_info.tags.find(function(code) {
        return code.indexOf('h1_') === 0;
      });
      var sling_color = product_info.tags.find(function(code) {
        return code.indexOf('slcl_') === 0;
      });
      var ribbon_color = product_info.tags.find(function(code) {
        return code.indexOf('rbcl_') === 0;
      });
      var case_color = product_info.tags.find(function(code) {
        return code.indexOf('cscl_') === 0;
      });
      /* 商品種別がケースでケースカラーがない場合はクリアとして扱う */
      if (caseH1Tags.includes(h1_code) && !case_color) {
        case_color = 'cscl_Clear';
      }
      //ケースタイプによって変数を変更(ケースタイプ追加時にこちらを変更)
      if (base_sling_color) {
        casetype_set(base_sling_color, sling_color, "slcl_", "スリングのカラーを選ぶ");
       } else if (base_ribbon_color) {
        casetype_set(base_ribbon_color, ribbon_color, "rbcl_", "リボンのカラーを選ぶ");
       }else{
        casetype_set("");
       }


      if (base_index_no === index_no) {

        /* デザインバリエーションが同一 */
        if (base_model_code !== 'mo_n000') {
          var valuePrefix = product_info.tags.find(function (code) {
            return code.startsWith('sp_sp_') || code.startsWith('fr_fb_'); // プレフィックスの判定
          });
          // 現在のケースタイプを判定して優先プレフィックスを設定
          var preferredPrefix;
          if (base_h1_code === 'h1_SP') {
            preferredPrefix = 'sp_sp_'; // スリムプロテクションケース
          }
          // 優先プレフィックスを考慮してmodel_linksに登録
          if (
            !model_links[model_code.slice(3)] || 
            valuePrefix === preferredPrefix
          ) {
            model_links[model_code.slice(3)] = product_info.handle;
          }
        }
        if (
          (
            base_model_code === 'mo_n000' &&
            model_code === 'mo_' + (typeof get_default_model === 'function' ? get_default_model() : 'ap2220')
          ) ||
          base_model_code === model_code ||
          model_code === 'mo_n000'
        ) {
          if (caseH1Tags.includes(h1_code)) {
            /* リンク用のhandleと画像のsrcを取得する */
            if (!casetype_selector[h1_code] && h1_code != 'h1_FM') {

              var variant_image = '';
              if(casetype_selector[h1_code] && casetype_selector[h1_code].variant_image){
                variant_image = casetype_selector[h1_code].variant_image;
              }

              casetype_selector[h1_code] = { 'handle': product_info.handle, 'image': product_info.images.edges[0].node.originalSrc, 'price': product_info.priceRange.minVariantPrice.amount, 'variant_image': variant_image };
              /* 現在表示中のh1と同じh1ならactiveをtrueに */
              if (h1_code == base_h1_code) {
                casetype_selector[h1_code].active = true;
              } else {
                casetype_selector[h1_code].active = false;
              }
            }
            /* ケースカラーバリエーション */
            if (base_h1_code == h1_code) {
              if (case_color) {
                if (!casecolor_links[case_color] || base_casetype_color == casetype_color) {
                  casecolor_links[case_color] = { 'handle': product_info.handle };
                  /* 現在表示中のh1と同じh1ならactiveをtrueに */
                  if (case_color == base_case_color) {

                    casecolor_links[case_color].active = true;
                    // casetype_selector[h1_code]が存在するか確認してからvariant_imageを設定
                    if (casetype_selector[h1_code]) {
                      casetype_selector[h1_code].variant_image = product_info.images.edges[0].node.originalSrc;
                    } else {
                      console.warn('casetype_selector[' + h1_code + ']が存在しません');
                    }

                    console.log(casecolor_links[case_color])
                  } else {
                    casecolor_links[case_color].active = false;
                    /* タグがケースタイプの中に含まれていればケースタイプ違いのリストに入れる */
                  }
                }
              }
            }
            if(h1_code == 'h1_FM'){

              var h1_color_name = case_color.replace('with BlackRing', '').replace('with WhiteRing', '');

              if(case_color && case_color.includes('with BlackRing')){

                var h1_FM_black_ring = { 'handle': product_info.handle, 'image': product_info.images.edges[0].node.originalSrc, 'price': product_info.priceRange.minVariantPrice.amount, 'active': false, 'variant_image': casetype_selector['h1_FM_black_ring'] ? casetype_selector['h1_FM_black_ring'].variant_image : product_info.images.edges[0].node.originalSrc, 'variant_handle': casetype_selector['h1_FM_black_ring'] ? casetype_selector['h1_FM_black_ring'].variant_handle : product_info.handle };
                casetype_selector['h1_FM_black_ring'] = h1_FM_black_ring;

                if((case_color == base_case_color || base_case_color.includes(h1_color_name)) || (base_case_color == 'cscl_Clear' && case_color.includes('ClearFrame'))){
                  casetype_selector['h1_FM_black_ring'].variant_image = product_info.images.edges[0].node.originalSrc;
                  casetype_selector['h1_FM_black_ring'].variant_handle = product_info.handle;
                  if(h1_code == base_h1_code && base_case_color.includes('with BlackRing')){
                    if(casetype_selector['h1_FM']){
                      casetype_selector['h1_FM'].active = false;
                    }
                    casetype_selector['h1_FM_black_ring'].active = true;
                  }
                }
              }
              if(case_color && case_color.includes('with WhiteRing')){

                casetype_selector['h1_FM'] = { 'handle': product_info.handle, 'image': product_info.images.edges[0].node.originalSrc, 'price': product_info.priceRange.minVariantPrice.amount, 'active': false, 'variant_image': casetype_selector['h1_FM'] ? casetype_selector['h1_FM'].variant_image : '', 'variant_handle': casetype_selector['h1_FM'] ? casetype_selector['h1_FM'].variant_handle : product_info.handle };

                if((case_color == base_case_color || base_case_color.includes(h1_color_name)) || (base_case_color == 'cscl_Clear' && case_color.includes('ClearFrame'))){


                  // casetype_selector['h1_FM'].variant_image = product_info.images.edges[0].node.originalSrc;
                  // casetype_selector['h1_FM'].variant_handle = product_info.handle;
                  if(h1_code == base_h1_code && base_case_color.includes('with WhiteRing')){
                    if(casetype_selector['h1_FM_black_ring']){
                      casetype_selector['h1_FM_black_ring'].active = false;
                    }
                    casetype_selector['h1_FM'].active = true;
                  }
                }
              }
            }

          }
         /* ケースタイプのカラーバリエーション */
          if (window.fox.settings.h1case_casetype.includes(base_h1_code) && base_h1_code == h1_code) {
            if (base_case_color == case_color) {
                casetype_links[casetype_color] = { 'handle': product_info.handle };
                /* 現在表示中のh1と同じh1ならactiveをtrueに */
                if (casetype_color == base_casetype_color) {
                  casetype_links[casetype_color].active = true;
                } else {
                  casetype_links[casetype_color].active = false;
                  /* タグがケースタイプの中に含まれていればケースタイプ違いのリストに入れる */
                }
            }
          }
        }
        if(h1_code && case_color && casetype_selector[h1_code] && casetype_selector[h1_code].variant_image == '' && h1_code != 'h1_FM'){
          if(case_color == base_case_color || base_case_color.includes(case_color.replace('with BlackRing', '').replace('with WhiteRing', ''))){
            casetype_selector[h1_code].variant_image = product_info.images.edges[0].node.originalSrc;
            casetype_selector[h1_code].variant_handle = product_info.handle;
          }
        }
      }
    }

    var selected_model = '';
    if (Object.keys(model_links).length) {
      $('.product-links .row.model').removeClass('d-none');
      ref2 = window.fox.settings.model_groups;
      for (m = 0, len3 = ref2.length; m < len3; m++) {
        var model_group = ref2[m];
        var $optgroup = $('<optgroup>');
        $optgroup.attr('label', model_group.label);
        var append_flg = false;
        var ref3 = model_group.code_sort;

        for (n = 0, len4 = ref3.length; n < len4; n++) {
          model_code = ref3[n];
          if (model_links[model_code]) {
            $option = $('<option>').val(model_links[model_code]).data('model', model_code).text(window.fox.settings.model[model_code]);
            if (model_code === base_model_code.slice(3)) {
              selected_model = model_links[model_code];
            }
            $optgroup.append($option);
            append_flg = true;
          }
        }
        if (append_flg) {
          $('.model_selector').append($optgroup);
        }
      }
      $('.model_selector').val(selected_model);
      $('.selector-container.is-model').removeClass('d-none');

      // 機種選択とメーカーフィルタリングを初期化
      setupModelFiltering();
    }

    /* ケースタイプボタンの生成 */


// ----- ここから追加コード（修正版） -----

// カラーの情報を収集
var frameColors = {
  h1_SP: new Set(),
  h1_FR: new Set()
};

products.forEach(function(product) {
  var tags = product.node.tags;
  var h1_code = tags.find(tag => tag.startsWith('h1_'));
  var case_color = tags.find(tag => tag.startsWith('cscl_'));

  if ((h1_code === 'h1_SP' || h1_code === 'h1_FR') && case_color) {
    frameColors[h1_code].add(case_color);
  }
});

// ケースタイプごとに条件をチェックして画像を変更
Object.keys(casetype_selector).forEach(function(h1_code) {
  if (h1_code === 'h1_FR') {
    var current_path = window.location.pathname;
    var produtct_handle = window.Products.handle;
    if(current_path.includes(casetype_selector[h1_code].handle) ){
      // プレミアムケースに複数のフレームカラーがある場合のみメイン画像を使用
      if (frameColors['h1_FR'].has('cscl_ClearFrame') && frameColors['h1_FR'].has('cscl_ClearBlackFrame')) {
        casetype_selector[h1_code].image = product_json.images[0]; // ← ここを1枚目に変更
      }
    }
  }
  // h1_SPは画像を変更しない（元のまま）
});

// ----- ここまで追加コード（修正版） -----





    var casetype_selector_template_content = $('#js_casetype_selector').html();
    var casetype_selector_template = _.template(casetype_selector_template_content);
    
    console.log({casetype_selector});
    for (casetype_label in casetype_selector) {
       // スリムプロテクションケースorスリムプロテクションプレミアムケースorマグセーブ対応ケースのみ表示
      if(casetype_label === 'h1_SP' || casetype_label === 'h1_FR' || casetype_label === 'h1_FM'  || casetype_label === 'h1_FM_black_ring'
       ) {
        var handle =  casetype_selector[casetype_label]['variant_handle'] ? casetype_selector[casetype_label]['variant_handle'] : casetype_selector[casetype_label]['handle'];
        var image_url = casetype_selector[casetype_label].image;
        if(casetype_label !== 'h1_FM' && casetype_selector[casetype_label].variant_image){
          image_url = casetype_selector[casetype_label].variant_image;
        }
        var active = casetype_selector[casetype_label]['active'];
        // 価格小数点以下表示のため変更
        var price = (casetype_selector[casetype_label]['price']).toLocaleString();
        // 新しい説明データを使用して説明文を取得
        var description = caseTypeDescriptions[casetype_label] || '';
        // テンプレートに説明文を追加
        var casetype_selector_html = casetype_selector_template({ 
          'handle': '/products/'+handle,
          'image_url': image_url, 
          'price': price, 
          'active': active, 
          'description': description 
        });
        $('.casetype-container').append(casetype_selector_html);
      }
    }
    if (isCaseProduct) {
      var current_casetype_name = window.fox.settings.h1case[base_h1_code];
      if(base_h1_code == 'h1_FM' && base_case_color.includes('with BlackRing')){
        current_casetype_name = window.fox.settings.h1case['h1_FM_black_ring'];
      }
      $('#js_casetype_name').text(current_casetype_name);
    }

    $('#js_casetype_selector').each(function (index, element) {
      return $(this).html($(this).find('a').sort(function (a, b) {
        if ($(a).data('handle') < $(b).data('handle')) {
          return -1;
        } else {
          return 1;
        }
      }));
    });

    $('#js_casetype_selector a').on('click', function() {
      return location.replace($(this).attr('href'));
    });

    /* ケースカラー選択ボタンの生成 */
    var color_selector_template_content = $('#js_color_selector').html();
    var color_selector_template = _.template(color_selector_template_content);
    console.log({casecolor_links})
    if (base_case_color) {
      $('.selector-container.is-casecolor').removeClass('d-none');
      for (casecolor_label in casecolor_links) {
        var handle = '/products/'+casecolor_links[casecolor_label]['handle'];
        var active = casecolor_links[casecolor_label]['active'];
        var casecolor_name = casecolor_label.replace("cscl_", "");
        var casecolor_selector_html = color_selector_template({ 'handle': handle, 'color': casecolor_name, 'active': active });
        if(base_h1_code == 'h1_FM'){
          if((casecolor_name.includes('BlackRing') && base_case_color.includes('BlackRing')) || (casecolor_name.includes('WhiteRing') && !base_case_color.includes('BlackRing'))){
            $('#js_casecolor_container').append(casecolor_selector_html);
          }
        }else{
          $('#js_casecolor_container').append(casecolor_selector_html);
        }
      }

      $('#js_casecolor_label').text(base_case_color.replace("cscl_", "").replace('with BlackRing', '').replace('with WhiteRing', ''));
    }
    /* スリングカラーとリボンカラー選択ボタンの生成 */
    if (base_casetype_color) {
      $('.selector-container.is-casetypecolor').removeClass('d-none');
      for (casetypecolor_label in casetype_links) {
        var handle = casetype_links[casetypecolor_label]['handle'];
        var active = casetype_links[casetypecolor_label]['active'];
        var casetypecolor_name = casetypecolor_label.replace(casetypecolor_label_replace, "");
        var casetypecolor_links_html = color_selector_template({ 'handle': handle, 'color': casetypecolor_name, 'active': active });
        $('#js_casetypecolor_container').append(casetypecolor_links_html);
      }
    }
    if (casetypecolor_label_replace) {
      $('#js_casetypecolor_label').text(base_casetype_color.replace(casetypecolor_label_replace, ""));
    }
    $('.is-casetypecolor h3').text(casetypecolor_text);

    $('.model_selector').on('change', function() {
      return location.replace($(this).val());
    });

    if (base_model_code === 'mo_n000') {
      base_model_code = 'mo_' + (typeof get_default_model === 'function' ? get_default_model() : 'ap2220');
    }

    //優先表示にはpriority_タグをつける
    priority_tag = 'priority_';
    return get_all_products_graphql(priority_tag , function(products) {
      var max_product_length = isSmartPhone ? 5 : 7;

      for (var o = products.length - 1, len5 = o - max_product_length; o > len5 && o >= 0 ; o--) {
        product = products[o];
        product_info = product.node;
        index_no = product_info.tags.find(function(code) {
          return code.indexOf('index_') === 0;
        });
        if (product_info.images.edges[0]) {
          var $append_tag = $('<div data-handle="' + product_info.handle + '">').append($('<a href="' + product_info.handle + '">').append($('<img src="' + product_info.images.edges[0].node.originalSrc + '">')));
          var kind = 'case';
          $('.design-valiation-slider.' + kind).append($append_tag);
        }
      }
      var priority_tag_length = products.length;

      var query_tag = '';
      if (
        base_h1_code === 'h1_PG' // note Protection Glass
      ) {
        query_tag = 'tag:\\"' + design_code + '\\" AND (tag:\\"' + base_model_code + '\\" OR tag:\\"mo_n000\\")';
      } else {
        query_tag = '((tag:\\"' + base_player_code + '\\" OR tag:\\"' + base_collection_code + '\\" OR tag:\\"' + base_f_code + '\\") AND tag:\\"' + base_model_code + '\\" NOT tag:\\"' + priority_tag + '\\" )';
      }
      return get_all_products_graphql(query_tag, function(products) {
        if(products.length - 1 == 0){
          $('.similar-design-container').addClass('d-none');
        }
        for (var o = products.length - 1  , len5 = max_product_length - priority_tag_length ; o >= 0 && len5 > 0 ; o-- , len5--) {
          product = products[o];
          product_info = product.node;
          //ケース名とデザイン名、金額を下部に表示
          var base_casetype_name = product_info.tags.find(function(code) {
            return code.indexOf('h1_') === 0;
          });
          if (base_casetype_name){
            var base_casetype_name = window.fox.settings.h1[base_casetype_name];
          }
          var base_itemtitle = product_info.tags.find(function(code) {
            return code.indexOf('productname_') === 0;
          });
          if (base_itemtitle) {
            base_itemtitle = base_itemtitle.replace('productname_','')
          }
          var base_players_name = product_info.tags.find(function(code) {
            return code.indexOf('pl_') === 0;
          });
          if (base_players_name) {
            base_players_name = base_players_name.replace('pl_','')
          } else {
            base_players_name = ""
          }
          var product_Price = product_info.priceRange.minVariantPrice.amount
          product_Price = product_Price.replace('.0','')
          product_Price = Number(product_Price).toLocaleString();

          if (product_info.handle ===  product_handle ) {
            len5++;
            continue;
          }
          index_no = product_info.tags.find(function(code) {
            return code.indexOf('index_') === 0;
          });
          if (product_info.images.edges[0]) {
            if (base_casetype_name && base_itemtitle ) {
              var $append_tag = $('<div data-handle="' + product_info.handle + '">').append($('<a href="' + product_info.handle + '">').append($('<img src="' + product_info.images.edges[0].node.originalSrc + '">')).append($("<p class=product-slideShow-lp>"+ base_players_name +"<p>")).append($("<p class=product-slideShow-title>"+ base_casetype_name +" [" +base_itemtitle+ "]<p>")).append($("<p class=product-slideShow-price>¥"+ product_Price +" <p>")));
            } else {
              var $append_tag = $('<div data-handle="' + product_info.handle + '">').append($('<a href="' + product_info.handle + '">').append($('<img src="' + product_info.images.edges[0].node.originalSrc + '">')).append($("<p class=product-slideShow-lp>"+ base_players_name +"<p>")).append($("<p class=product-slideShow-title>"+ product_info.title + "<p>")).append($("<p class=product-slideShow-price>¥"+ product_Price +" <p>")));
            }
            var kind = 'case';
            $('.design-valiation-slider.' + kind).append($append_tag);
          }
        }
        return $('.design-valiation-container').each(function(index, element) {
          if (
            $(element).find('.design-valiation-slider > div').length
          ) {
            $(element)
              .find('.design-valiation-slider')
              .html($(element)
              .find('.design-valiation-slider > div')
              );
            if (isCaseProduct) {
              $(element).removeClass('d-none');
            }
            $(element)
              .find('.js-see-more-similar-design')
              .attr('href', '/collections/all/?sort_by=created-descending')
          }
        });
      });
    })
  });


  $('.modaal').modaal();

  // note 商品画像が2枚以上登録されている場合にサムネイルをカルーセルにする
  if ($('.js-product-thumbnails').length) {
    $('.js-product-thumbnails-container').slick({
      infinite: true,
      slidesToShow: 5,
      slidesToScroll: 5,
      speed: 500 ,
      lazyLoad: 'progressive',
      prevArrow:'<button class="slick-arrow slick-prev"><svg><use xlink:href="#icon-slideshow-previous2"></use></svg></button>',
      nextArrow:'<button class="slick-arrow slick-next"><svg><use xlink:href="#icon-slideshow-next2"></use></svg></button>'
    });
  }

  // note プロテクタースクリーンのついで買い関連の処理
  if (window.matchMedia('(max-width: 600px)').matches) {
    var buytogether_template_content = $('#js_buytogether-sp').html();
  } else {
    var buytogether_template_content = $('#js_buytogether').html();
  }

  var buytogether_template = _.template(buytogether_template_content);
  var buyTogetherAccessoryList = window.fox.settings.buyTogetherAccessoryList;

  var getOfBuyTogetherAccessory = function(query , callback ) {
    $.ajax({
      type: 'POST',
      timeout: 8000,
      url: '/api/2019-07/graphql.json',
      headers: {
        'Content-Type': 'application/graphql',
        'X-Shopify-Storefront-Access-Token': ACCESS_TOKEN_STORE_FRONT_API
      },
      data: '{ products(query: "' + query + '", first: 250) { edges { cursor, node { id, handle, title, tags, publishedAt, productType, priceRange { minVariantPrice { amount } }, variants(first: 1) { edges { node { id, availableForSale } } }, images(first:1) { edges { node { originalSrc } } } } }, pageInfo { hasNextPage } } }',
      cache: false
    }).done(function(resp) {
      $(window).on('load', function() {
        //spチェック時のカラーを選択
        var accessory_choice_add = {
          color:"#FFF",
          background:"#f85b58"
        }
        var accessory_choice_remove = {
          color:"#000",
          background:"#FFF"
        }
        if (window.matchMedia('(max-width: 600px)').matches) {
          $('.js-ly-product-add .mod-checkbox-sp').addClass('d-none');
          var label_num = $('.is-buytogether-sp label').length;
          if (label_num <= 2) {
            $('.is-buytogether-sp').css('padding-left','20px');
          }
        } else {
          $('.js-ly-product-add .buytogether-wrapper').addClass('d-none');
        }
        //チェックつけた商品のポップアップに表示されている、アクセサリー項目を表示(pc)
        $('.mod-checkbox').change(function() {
          var accessoryclassName = $(this).parents(".buytogether-wrapper").attr("class");
          if (accessoryclassName) {
          var cartaddcheck_num = accessoryclassName.replace(/[^0-9]/g, '');
          }
          if ($(this).children("input[name=buytogether]").is(':checked')) {
            $('.js-ly-product-add .accessory'+cartaddcheck_num+'').removeClass('d-none');
          } else {
            $('.js-ly-product-add .accessory'+cartaddcheck_num+'').addClass('d-none');
          }
        });
        //(sp)
        $('.mod-checkbox-sp').change(function() {
          var accessoryclassName = $(this).attr("class");
          if (accessoryclassName) {
          var cartaddcheck_num = accessoryclassName.replace(/[^0-9]/g, '');
          }
          if ($(this).children("input[name=buytogether]").is(':checked')) {
            $(this).find('.buytogether-price-sp,.buytogether-introduction, .js-buytogether-model').css(accessory_choice_add);
            $(this).find('.buytogether-introduction .name').css('color',"#FFF");
            $('.js-ly-product-add .accessory'+cartaddcheck_num+'').removeClass('d-none');
          } else {
            //チェック外したら色を戻す
            $(this).find('.buytogether-price-sp, .buytogether-introduction, .js-buytogether-model').css(accessory_choice_remove);
            $(this).find('.buytogether-price-sp').css('color',"#f85b58");
            $(this).find('.buytogether-introduction .name').css('color',"#000");
            $('.js-ly-product-add .accessory'+cartaddcheck_num+'').addClass('d-none');
          }
        });
      });

      var edges = resp.data.products.edges;
      return callback(edges);
    }).fail(function(e) {
      return console.error(e);
    })
  };

  var queryGetOfBuyTogetherAccessory = function (accessoryTag, searchParameter) {
    if (searchParameter == ACCESSORY_QUERY_MODEL) {
      return 'tag:\\"' + accessoryTag + '\\" AND tag:\\"' + base_model_code + '\\"';
    } else if(searchParameter == ACCESSORY_QUERY_DESIGN) {
      return 'tag:\\"' + accessoryTag + '\\" AND tag:\\"' + design_code + '\\" AND tag:\\"' + base_index_no + '\\"';
    } else {
      return 'tag:\\"' + accessoryTag + '\\"';
    }
  };
  var buyTogetherAccessoryList = [];
  var buyTogetherAccessoryList = window.fox.settings.buyTogetherAccessoryList;
  if ( isCaseProduct ) {
    for (let i = 0; i < buyTogetherAccessoryList.length; ++i) {
      getOfBuyTogetherAccessory(
        queryGetOfBuyTogetherAccessory(buyTogetherAccessoryList[i].tag, buyTogetherAccessoryList[i].query),
        function (edges) {
          if (edges.length > 0) {
            var model_code = 'for ' + base_model_name;
            var productClassName = 'accessory'+[i]+'';
            var productAvailableForSale = edges[0].node.variants.edges[0].node.availableForSale;
            var productId = edges[0].node.variants.edges[0].node.id;
            productId = atob(productId).split('/').pop();
            var productName = edges[0].node.title;
            var productUrl = edges[0].node.handle;
            var productPrice = edges[0].node.priceRange.minVariantPrice.amount;
            productPrice = Math.round(productPrice).toLocaleString();
            var productImageUrl = edges[0].node.images.edges[0].node.originalSrc;
            var cut = "for";
            var pos = productName.split(cut);

            var productIsProtectionGlass = function(){
              if( buyTogetherAccessoryList[i].tag == 'h1_PG' ){
                return true;
              } else {
                return false;
              }
            }
            if (productIsProtectionGlass()) {
              productName = '【画面割れ補償付き】' + productName;
            }
            function textTrim(text, count) {
              if (text.length > count) {
                var showText = text.substring(0, count);
                showText += '…';
                return showText;
              } else {
                return text;
              }
            }
            if (productAvailableForSale) {
              $('#js_buytogether_container').removeClass('d-none');
              var buytogether_html = buytogether_template({'productClassName': productClassName ,'model_code': model_code, 'sortNum': i, 'productUrl': productUrl, 'productName': productName, 'productId': productId, 'productImageUrl': productImageUrl, 'productPrice': productPrice, 'productIsProtectionGlass': productIsProtectionGlass() });
              if (window.matchMedia('(max-width: 600px)').matches) {
                productNameCut = productName.replace('【画面割れ補償付き】','');
                productNameCut = (pos[0]+cut).replace('for','');
                productNameCut = textTrim(productNameCut, 11);
                var buytogether_html_productNameCut = buytogether_template({'productClassName': productClassName ,'model_code': model_code, 'sortNum': i, 'productUrl': productUrl, 'productName': productNameCut, 'productId': productId, 'productImageUrl': productImageUrl, 'productPrice': productPrice, 'productIsProtectionGlass': productIsProtectionGlass() });
                $('.is-buytogether-sp').append(buytogether_html_productNameCut);
                $('.product-add-buytogether-sp').append(buytogether_html);
              } else {
                $('.is-buytogether').append(buytogether_html);
              }
            }
          }
        }
      )
    }
  }


  // note ケース以外の商品詳細画面の場合は、『素材で選ぶ』『アクセサリを追加』『Similar Design Case』 を消す
  if (!isCaseProduct) {
    $('.selector-container.is-casetype').addClass('d-none');
    $('.buytogether-container').addClass('d-none');
    $('.similar-design-container').addClass('d-none');
  }

  // note 形状素材についてのモーダルの中身を出し分ける
  if (isCaseProduct) {
    $('.js-material-case-content').removeClass('d-none');
  } else {
    $('.js-material-protection-glass-content').removeClass('d-none');
  }


  // buytogether-checkboxを選択したらカートに追加しましたテンプレートに商品を追加、削除する
  var buytogetherAddCartProducts = [];

  $('.buytogether-checkbox').change(function() {
    if ($(this).is(':checked')) {
      var details = {
        title: $(this).closest('.inner').find('.title').text(),
        price: $(this).closest('.inner').find('.price').html(),
        image: $(this).closest('.inner').find('img').attr('src'),
      }
      buytogetherAddCartProducts.push(details);
    } else {
      buytogetherAddCartProducts = buytogetherAddCartProducts.filter(function(item) {
        return item !== $(this).val();
      });
    }
    console.log(buytogetherAddCartProducts);
    $('.is-buytogether').html('');
    buytogetherAddCartProducts.forEach(function(item) {
      var price = item.price.replace(/（税込）/g, '');

      var html = `
      <div class="inner product-add-case">
        <div class="image-container">
          <img src="${item.image}" alt="${item.title}" width="60">
        </div>
        <div class="introductions-header">
          <p class="title">${item.title}</p>
          <div class="product-price">
            <strong>${price}</strong>
            <!-- <span class="unit"></span> -->
          </div>
        </div>
      </div>
      `;
      $('.is-buytogether').append(html);
    });
  });


});

// theme.jsで読み込ませるためglobal関数にする
function buyTogetherAddCart() {
  var buytogetherAddCartProducts = [];
  $('[class="buytogether-checkbox"]:checked').each(function () {
    var buytogetherAddCartProducts_value = $(this).val();
    buytogetherAddCartProducts.push(Number(buytogetherAddCartProducts_value));
  });
  var data = {items:[]};
  for (let i = 0; i < buytogetherAddCartProducts.length; ++i) {
    data.items[i]  = { quantity: 1, id: buytogetherAddCartProducts[i] };
  }
  $.ajax({
    url:'/cart/add.js',
    type: 'post',
    dataType: 'json',
    data: data
  })
}


// 機種選択とメーカーの条件分岐を初期化する関数
function setupModelFiltering() {
      const tags = $('.js-section-product').data('product-json').tags || [];
      const hasOwnUI = tags.some(t => ['h1_AP','h1_GBP','h1_GB2P','h1_GB2','h1_AWCB','h1_AWLB'].includes(t));
      if (hasOwnUI) return
  const seriesSelector = document.querySelector('.series');
  const modelSelector = document.querySelector('.model_selector.models');

  if (!seriesSelector || !modelSelector) {
    console.log('セレクトボックスが見つかりません');
    return;
  }

  // 既存のoptionから元のデータを保存
  const originalOptions = Array.from(modelSelector.querySelectorAll('optgroup')).map(optgroup => ({
    label: optgroup.getAttribute('label'),
    options: Array.from(optgroup.querySelectorAll('option')).map(option => ({
      value: option.value,
      text: option.textContent,
      modelCode: option.getAttribute('data-model') || null
    }))
  }));

  console.log('originalOptions:', originalOptions); // デバッグ用

  // 既存のイベントリスナーを削除（jQueryを使って）
  $('.series').off('change.modelFiltering');

  // シリーズ選択時の処理（jQueryを使用）
  $('.series').on('change.modelFiltering', function () {
    const selectedSeriesLabel = $(this).find('option:selected').text();
    console.log('メーカー選択:', selectedSeriesLabel); // デバッグ用

    // 機種セレクトボックスをクリア
    $('.model_selector.models').empty();

    // プレースホルダーを追加
    $('.model_selector.models').append('<option value="" disabled selected>Choose by Devices</option>');

    // 元のデータから選択されたメーカーに対応する機種を取得
    const matchingGroup = originalOptions.find(group => group.label === selectedSeriesLabel);
    console.log('マッチしたグループ:', matchingGroup); // デバッグ用
    
    if (matchingGroup) {
      const $optgroup = $('<optgroup>').attr('label', selectedSeriesLabel);
      
      matchingGroup.options.forEach(optionData => {
        const $option = $('<option>')
          .val(optionData.value)
          .text(optionData.text);
        if (optionData.modelCode) {
          $option.attr('data-model', optionData.modelCode);
        }
        $optgroup.append($option);
      });
      
      if ($optgroup.children().length > 0) {
        $('.model_selector.models').append($optgroup);
      }
      console.log('機種オプション追加完了:', $optgroup.children().length); // デバッグ用
    } else {
      console.log('マッチするグループが見つかりません'); // デバッグ用
    }
  });
}


//イヤホンケース Apple Watchクリアバンド Apple Watchレザーバンド レンズガラスの機種を選ぶコード

document.addEventListener('DOMContentLoaded', function () {
  const productTags = $('.js-section-product').data('product-json').tags;
  const seriesSelector = document.querySelector('.series');
  const modelSelector = document.querySelector('.model_selector.models');

  if (!seriesSelector || !modelSelector) return;

  const baseH2Tag = productTags.find(tag => tag.startsWith('h2_'));
  const baseCode = baseH2Tag ? baseH2Tag.replace('h2_', '').replace(/^cl/i, '').toLowerCase() : null;
  const indexTag = productTags.find(tag => tag.startsWith('index_'));
  const indexNumber = indexTag ? indexTag.replace('index_', '') : '11';

  const currentH1Tag = productTags.find(tag => [
    'h1_AP', 'h1_GBP', 'h1_GB2P', 'h1_GB2', 'h1_AWCB', 'h1_AWLB'
  ].includes(tag));

  const config = {
    'earphone': {
      tags: ['h1_AP', 'h1_GBP', 'h1_GB2P', 'h1_GB2'],
      brands: ['AP', 'SS'],
      models: {
        AP: [
          { name: 'AirPods Pro', suffix: 'ap2157' },
          { name: 'AirPods 2nd Generation', suffix: 'ap2155' },
          { name: 'AirPods 1st Generation', suffix: 'ap2154' }
        ],
        SS: [
          { name: 'Galaxy Buds2', prefix: 'gb2_pc_' },
          { name: 'Galaxy Buds2 Pro', prefix: 'gb2p_gb2p_' },
          { name: 'Galaxy Buds Pro', prefix: 'gbp_gbp_' }
        ]
      }
    },
    'h1_AWCB': {
      brands: ['AP'],
      prefix: 'awcb_awcbtpu_',
      models: [
        { name: 'Apple Watch（38mm〜41mm）', modelCode: 'ap2158' },
        { name: 'Apple Watch（42mm〜45mm）', modelCode: 'ap2159' }
      ]
    },
    'h1_AWLB': {
      brands: ['AP'],
      prefix: 'awlb_awlbvl_',
      models: [
        { name: 'Apple Watch（38mm〜41mm）', modelCode: 'ap2158' },
        { name: 'Apple Watch（42mm〜45mm）', modelCode: 'ap2159' }
      ]
    }
  };

  if (!currentH1Tag || !baseCode) return;

  // 商品タイプの判別 (イヤホンケース or Apple Watch)
  const isEarphone = config.earphone.tags.includes(currentH1Tag);
  const itemConfig = isEarphone ? config.earphone : config[currentH1Tag];

  seriesSelector.innerHTML = '<option value="" disabled selected>Choose by Maker</option>';
  itemConfig.brands.forEach(brand => {
    const option = document.createElement('option');
    option.value = brand;
    option.textContent = brand === 'AP' ? 'Apple' : brand === 'SS' ? 'Samsung' : brand;
    seriesSelector.appendChild(option);
  });

  modelSelector.style.display = 'none';
  modelSelector.innerHTML = '';

  seriesSelector.addEventListener('change', function () {
    const selectedBrand = this.value;
    modelSelector.innerHTML = '<option value="" disabled selected>Choose by Devices</option>';

    if (isEarphone) {
      const models = itemConfig.models[selectedBrand];
      models.forEach(model => {
        let handle;
        if (selectedBrand === 'AP') {
          handle = `ap_aptpu_cl${baseCode}-${indexNumber}_${model.suffix}`;
        } else if (selectedBrand === 'SS') {
          handle = `${model.prefix}cl${baseCode}-${indexNumber}_n000`;
        }

        const option = document.createElement('option');
        option.value = handle;
        option.textContent = model.name;
        modelSelector.appendChild(option);
      });
    } else if (['h1_AWCB', 'h1_AWLB'].includes(currentH1Tag)) {
      itemConfig.models.forEach(model => {
        let handle = `${itemConfig.prefix}cl${baseCode}-${indexNumber}_${model.modelCode}`;

        const option = document.createElement('option');
        option.value = handle;
        option.textContent = model.name;
        modelSelector.appendChild(option);
      });
    }

    modelSelector.style.display = 'block';
  });

  modelSelector.addEventListener('change', function () {
    window.location.href = `/products/${this.value}`;
  });
});





document.addEventListener('DOMContentLoaded', function () {
  const productTags = $('.js-section-product').data('product-json').tags;

  if (productTags.includes('h1_LG3') || productTags.includes('h1_LG2')) {
    const seriesSelector = document.querySelector('.series');
    const modelSelector = document.querySelector('.model_selector.models');

    if (!seriesSelector || !modelSelector) return;

    // メーカーはAppleのみ
    seriesSelector.innerHTML = `
      <option value="" disabled selected>Choose by Maker</option>
      <option value="AP">Apple</option>
    `;

    // 初期状態では機種セレクトボックスを非表示に設定
    modelSelector.style.display = 'none';
    modelSelector.innerHTML = '';

    const lensGlassModels = [
      { name: 'iPhone 15', url: 'https://global.caseplay.shop/collections/h1_lg/products/lg2-ap-ap2221_22-bk' },
      { name: 'iPhone 15 Pro', url: 'https://global.caseplay.shop/collections/h1_lg/products/lg3-ap-ap2223_24-gy' },
      { name: 'iPhone 15 Plus', url: 'https://global.caseplay.shop/collections/h1_lg/products/lg2-ap-ap2221_22-bk' },
      { name: 'iPhone 15 Pro Max', url: 'https://global.caseplay.shop/collections/h1_lg/products/lg3-ap-ap2223_24-gy' },
      { name: 'iPhone 14', url: 'https://global.caseplay.shop/collections/h1_lg/products/lg2-ap-ap2179_80-bk' },
      { name: 'iPhone 14 Pro', url: 'https://global.caseplay.shop/collections/h1_lg/products/lg3-ap-ap2181_82-bk' },
      { name: 'iPhone 14 Plus', url: 'https://global.caseplay.shop/collections/h1_lg/products/lg2-ap-ap2179_80-bk' },
      { name: 'iPhone 14 Pro Max', url: 'https://global.caseplay.shop/collections/h1_lg/products/lg3-ap-ap2181_82-bk' },
      { name: 'iPhone 13 mini', url: 'https://global.caseplay.shop/collections/h1_lg/products/lg2-ap-ap2110_11-bk' },
      { name: 'iPhone 13', url: 'https://global.caseplay.shop/collections/h1_lg/products/lg2-ap-ap2110_11-bk' },
      { name: 'iPhone 13 Pro', url: 'https://global.caseplay.shop/collections/h1_lg/products/lg3-ap-ap2112_13-bk' },
      { name: 'iPhone 13 Pro Max', url: 'https://global.caseplay.shop/collections/h1_lg/products/lg3-ap-ap2112_13-bk' }
    ];

    // メーカー選択時のイベント
    seriesSelector.addEventListener('change', function () {
      modelSelector.innerHTML = '<option value="" disabled selected>Choose by Devices</option>';

      lensGlassModels.forEach(model => {
        const option = document.createElement('option');
        option.value = model.url;
        option.textContent = model.name;
        modelSelector.appendChild(option);
      });

      modelSelector.style.display = 'block';
    });

    // 機種選択時のURL遷移
    modelSelector.addEventListener('change', function () {
      window.location.href = this.value;
    });
  }
});





//液晶保護ガラスの機種を選ぶコード

document.addEventListener('DOMContentLoaded', function () {
  const productTags = $('.js-section-product').data('product-json').tags;

  if (productTags.includes('h1_PG')) {
    const seriesSelector = document.querySelector('.series');
    const modelSelector = document.querySelector('.model_selector.models');

    // メーカーを全て表示
    seriesSelector.innerHTML = `
      <option value="" disabled selected>Choose by Maker</option>
      <option value="AP">Apple</option>
      <option value="GG">Google</option>
      <option value="SS">Samsung</option>
      <option value="SN">Sony</option>
      <option value="SH">SHARP</option>
      <option value="OP">OPPO</option>
      <option value="XM">Xiaomi</option>
      <option value="MT">Motorola</option>
      <option value="FC">FCNT</option>
      <option value="ZT">ZTE</option>
      <option value="HW">HUAWEI</option>
    `;

    // 初期状態では非表示に設定
    modelSelector.style.display = 'none';
    modelSelector.innerHTML = '';

    // 機種オプション生成処理（valueをpg-cl-[メーカー]-[機種コード]-11に設定）
    const setModelOptions = (brandCode) => {
      modelSelector.innerHTML = '<option value="" disabled selected>Choose by Devices</option>';

      const optgroup = document.createElement('optgroup');
      optgroup.label = seriesSelector.querySelector(`option[value="${brandCode}"]`).innerText;

      // メーカーコードに基づく機種データの取得
      const models = window.fox.settings.model_groups.find(group => group.code === brandCode).code_sort;

      models.forEach(modelCode => {
        const modelName = window.fox.settings.model[modelCode];
        if (modelName) {
          const option = document.createElement('option');

          // value値を "pg-cl-[メーカーコード]-[機種コード]-11" の形に設定
          option.value = `pg-cl-${brandCode}-${modelCode.toLowerCase()}-11`;
          option.innerText = modelName;
          optgroup.appendChild(option);
        }
      });

      modelSelector.appendChild(optgroup);
      modelSelector.style.display = 'block';
    };

    // メーカー選択時の動作
    seriesSelector.addEventListener('change', function () {
      setModelOptions(this.value);
    });

    // 機種選択時の遷移処理（商品ページへの遷移）
    modelSelector.addEventListener('change', function () {
      const handle = this.value;
      window.location.href = `/products/${handle}`;
    });
  }
});
